export const regions = [
  { label: "US", value: "US" },
  { label: "World", value: "world" },
  { label: "North America", value: "North America" },
  { label: "Africa", value: "Africa" },
  { label: "Asia", value: "Asia" },
  { label: "Europe", value: "Europe" },
  { label: "South America", value: "South America" },
  { label: "Oceania", value: "Oceania" },
];

const baseMarketingUrl = import.meta.env.VITE_REACT_APP_BRAINTRUST_URL
const baseAppUrl =import.meta.env.VITE_REACT_APP_BRAINTRUST_APP_URL

export const NAV_LINKS = [
  {
    url: `${baseMarketingUrl}air`,
    label: "AI Recruiter (AIR)",
    subLinks: [
      {
        url: `${baseMarketingUrl}air-demo`,
        label: "Try AIR For Yourself",
      },
      {
        url: `${baseMarketingUrl}contact-sales`,
        label: "Contact Sales",
      },
    ],
  },
  {
    label: "Talent Marketplace",
    url: ``,
    subLinkGroups: [
      {
        label: "For Companies",
        url: ``,
        subLinks: [
          {
            url: `${baseMarketingUrl}solutions`,
            label: "Solutions",
          },
          {
            url: `${baseMarketingUrl}pricing`,
            label: "Pricing",
          },
          {
            url: `${baseMarketingUrl}why-braintrust`,
            label: "Why Braintrust",
          },
          {
            url: `${baseMarketingUrl}skills`,
            label: "Skills & Capabilities",
          },
          {
            url: `${baseMarketingUrl}clients`,
            label: "Case Studies",
          },
          {
            url: `${baseMarketingUrl}contact-sales`,
            label: "Contact Sales",
          },
        ],
      },
      {
        label: "For Talent",
        url: ``,
        subLinks: [
          {
            url: `${baseAppUrl}jobs`,
            label: "Jobs",
          },
          {
            url: `${baseMarketingUrl}how-it-works-for-talent`,
            label: "How it Works",
          },
          {
            url: `${baseMarketingUrl}community`,
            label: "Community",
          },
          {
            url: `${baseMarketingUrl}benefits`,
            label: "Benefits",
          },
          {
            url: `${baseMarketingUrl}refer-clients`,
            label: "Refer & Earn",
          },
        ],
      },
    ],
  },
  {
    url: `${baseMarketingUrl}about`,
    label: "Company",
    subLinks: [
      {
        url: `${baseMarketingUrl}about`,
        label: "About",
      },
      {
        url: `${baseMarketingUrl}blog`,
        label: "Blog",
      },
      {
        url: `${baseMarketingUrl}btrst-token`,
        label: "BTRST",
      },
      {
        url: `${baseMarketingUrl}press`,
        label: "Press",
      },
      {
        url: `https://info.app.usebraintrust.com/`,
        label: "Network Dashboard",
      },
    ],
  },
  {
    url: `${baseAppUrl}auth/login`,
    label: "Log in",
  },
];

export const SIGN_UP_LINK = `${baseAppUrl}auth/sign_up/goals`;

export const BOOK_DEMO_LINK = `${baseMarketingUrl}contact-sales`;
